import { createContext, useContext } from 'react'

import { Config } from './types/config'

export const ConfigContext = createContext({} as Config)

export const useConfig = () => useContext(ConfigContext)
